export default __webpack_public_path__ + "static/media/qemotion_login-logo@2x.e23e35c4.png";